<template>
  <div class="nav">
    <div @click="goToStorePage" class="item">
      <div class="child">去查看</div>
      <div class="child">更多商品</div>
    </div>
  </div>
</template>

<script>
import tuanMixin from "./mixin.js"

export default {
  name: "Nav",
  mixins: [tuanMixin]
}
</script>

<style scoped>
.nav {
  z-index: 3;
}
</style>
